import DashBoard from '../features/dashBoard/DashBoard';

const App = () => {
  return (
    <div className='App'>
      <header className='App-header'>
        <DashBoard />
      </header>
    </div>
  );
};

export default App;
